import { Component, inject } from '@angular/core';
import { ImportFlowService } from '@services/imports/import-flow.service';
import { CrossF7SettingsTable } from '@/table-settings/imports/cross-f7-settings-table';
import { TableColumnsSetting } from '@/interfaces/table-setting';
import { CrossF7DataSource } from '@components/new-table/data-sources/cross-f7.dataSource';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-cross-f7-table',
  templateUrl: './cross-f7-table.component.html',
  styleUrls: ['./cross-f7-table.component.scss'],
})
export class CrossF7TableComponent {
  displayedColumns: TableColumnsSetting<any>;

  dataSource = new CrossF7DataSource(this.importFlowService);

  toastr = inject(ToastrService);
  dialog = inject(MatDialog);

  reloadTrigger$ = new Subject<any>();

  constructor(private importFlowService: ImportFlowService) {
    this.displayedColumns = CrossF7SettingsTable.getColumnsSetting();
  }
}
